import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { List, ListItem } from '@material-ui/core';

import _ from 'lodash';
import FieldCard from 'components/Cards/FieldCard';

const FieldTiles = ({ fields, selectedField, setSelectedField, getFieldDevices }) => {
  const fieldCards = [];

  const selectField = (field) => {
    setSelectedField(field);
  };

  const getFieldUpdateTime = (field) => {
    return moment(field?.updated_at).unix();
  };

  const getFieldOnlineDevices = (field) => {
    return field && getFieldDevices(field) ? getFieldDevices(field).length : 0;
  };

  _.forEach(fields, (field) => {
    if (field) {
      const lastUpdateTime = getFieldUpdateTime(field);
      const onlineSensors = getFieldOnlineDevices(field);
      fieldCards.push(
        <ListItem key={field?.id} dense disableGutters divider>
          <FieldCard
            getFieldDevices={getFieldDevices}
            onlineSensors={onlineSensors}
            lastUpdateTime={lastUpdateTime}
            field={field}
            selectField={selectField}
            selected={field?.id === selectedField?.id}
          />
        </ListItem>
      );
    }
  });

  return <List>{fieldCards}</List>;
};

FieldTiles.propTypes = {
  getFieldDevices: PropTypes.func.isRequired,
  fields: PropTypes.array.isRequired,
  selectedField: PropTypes.object,
  setSelectedField: PropTypes.func.isRequired,
};

FieldTiles.defaultProps = {
  selectedField: undefined,
};

export default FieldTiles;
